import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../ConciergeEvent/conciergeEvent.css'
import Toggle from 'react-toggle'
import KashtaAddOns from './KashtaAddOns.js'

class ConciergeKashtaAdd extends React.Component {
  // Constants
  BOOKING_TYPE = 'KASHTA'
  INITIAL_LOADING_DELAY = 2000
  searchDebounceTimer = null

  state = {
    // Selection state
    category_id: '',
    company_id: '',
    event_id: '',
    slot_id: '',
    selected_slot: '',
    date: moment().format('YYYY-MM-DD'),

    // Search state
    company_search: '',

    // Filter state
    filterOpen: false,
    booking_date: '',
    filterCount: 0,

    // Data lists
    categoryList: [],
    companyList: [],
    eventList: [],
    available_timeslots: [],
    slots: [],
    calendarData: [],
    calendarDateCellStatus: {},

    // Calendar state
    calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
    timeSlotDrop: false,

    // Ticket state
    adultTicketCount: 1,
    childTicketCount: 0,
    adultTicketPrice: 0,
    childTicketPrice: 0,
    minTicketCount: 0,
    maxTicketCount: 0,
    totalTickets: 1,
    is_tickets_hide: false,

    // Customer info
    phone: '',
    email: '',
    country_code: '',

    // Coupon & pricing
    coupon: '',
    coupon_id: '',
    isCouponApplied: false,
    isCustomerOptional: false,
    cost_of_service: 0,
    enable_b2b_prices: false,

    // Booking state
    bookingData: {},
    isData: false,
    isLoading: false,
    initialLoading: false,

    // Individual loading states
    isLoadingCompanies: false,
    isLoadingEvents: false,
    isLoadingCalendar: false,
    isLoadingEventDetails: false,
    isBooking: false,

    // Event details modal
    eventDetails: null,
    showDetailsModal: false,

    // Addons popup
    addOnPopUp: 0,
    appOnData: {},

    // Payment confirmation modal
    showPaymentModal: false,

    // Validation errors
    emailError: '',
  }

  // Styles
  customStyle = {
    listBox: {
      padding: 10,
      borderRadius: 10,
      border: '1px solid #eee',
      backgroundColor: '#fefefe',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    listBoxSelected: {
      border: '2px solid #00547e',
      backgroundColor: '#f0f8ff',
    },
    listBoxImage: {
      height: 80,
      width: 80,
      objectFit: 'cover',
      borderRadius: 8,
    },
    listBoxLabel: {
      color: '#00547e',
      fontWeight: '600',
      fontSize: '15px',
      padding: '5px 0',
      textTransform: 'uppercase',
      margin: 0,
    },
  }

  componentDidMount() {
    this.initializeComponent()
  }

  componentWillUnmount() {
    // Clear debounce timer on unmount
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer)
    }
  }

  // Inline loader component
  renderInlineLoader = (height = 100) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: height,
          width: '100%',
        }}
      >
        <div
          style={{
            width: 30,
            height: 30,
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #00547e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    )
  }

  // Empty state component for better UI
  renderEmptyState = (iconType, title, subtitle = '') => {
    // Icon SVG based on type
    const getIconSvg = () => {
      switch (iconType) {
        case 'company':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <path d="M3 21h18M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16" />
            </svg>
          )
        case 'event':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                ry="2"
              />
              <line
                x1="16"
                y1="2"
                x2="16"
                y2="6"
              />
              <line
                x1="8"
                y1="2"
                x2="8"
                y2="6"
              />
              <line
                x1="3"
                y1="10"
                x2="21"
                y2="10"
              />
            </svg>
          )
        case 'time':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
              />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          )
        case 'ticket':
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <path d="M2 9a3 3 0 013-3h14a3 3 0 013 3v0a3 3 0 01-3 3v0a3 3 0 013 3v0a3 3 0 01-3 3H5a3 3 0 01-3-3v0a3 3 0 013-3v0a3 3 0 01-3-3z" />
              <path d="M13 6v4M13 14v4" />
            </svg>
          )
        default:
          return (
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6c757d"
              strokeWidth="1.5"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
              />
              <line
                x1="12"
                y1="8"
                x2="12"
                y2="12"
              />
              <line
                x1="12"
                y1="16"
                x2="12.01"
                y2="16"
              />
            </svg>
          )
      }
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px dashed #dee2e6',
          marginTop: '15px',
        }}
      >
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#e9ecef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px',
          }}
        >
          {getIconSvg()}
        </div>
        <h5
          style={{
            margin: '0 0 5px 0',
            fontSize: '16px',
            fontWeight: '600',
            color: '#495057',
          }}
        >
          {title}
        </h5>
        {subtitle && (
          <p
            style={{
              margin: 0,
              fontSize: '13px',
              color: '#6c757d',
              textAlign: 'center',
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    )
  }

  initializeComponent = () => {
    // Auto-enable B2B for concierge users
    if (localStorage['user_role'] === 'concierge') {
      this.setState({ enable_b2b_prices: true })
    }

    // Load initial data
    this.loadCategories()

    // Show initial loading
    this.setState({ initialLoading: true })
    setTimeout(() => {
      this.setState({ initialLoading: false })
    }, this.INITIAL_LOADING_DELAY)

    // Bind methods
    this.calendarDateColor = this.calendarDateColor.bind(this)
    this.calendarCell = this.calendarCell.bind(this)
  }

  // ==================== API Methods ====================

  loadCategories = async (keyword = '', booking_date = '') => {
    this.setState({
      isLoading: true,
      categoryList: [],
      companyList: [],
      eventList: [],
      company_id: '',
      event_id: '',
      category_id: '',
    })

    try {
      const params = { keyword }
      if (booking_date) {
        params.booking_date = booking_date
      }

      const response = await axios.get(`${Constant.getAPI()}/event-categories/categories/${this.BOOKING_TYPE}`, {
        headers: this.getHeaders(),
        params: params,
      })

      if (response.data.success) {
        const categories = response.data.data?.filter((cat) => cat.is_active === true) || []

        this.setState(
          {
            categoryList: categories,
            category_id: categories[0]?.id || '',
          },
          () => {
            if (categories.length > 0 && categories[0]?.id) {
              this.loadCompanies(categories[0].id, keyword, booking_date)
            } else {
              this.setState({ isLoading: false })
              if (categories.length === 0) {
                this.showInfoMessage('No active Kashta categories available')
              }
            }
          }
        )
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  loadCompanies = async (category_id, keyword = '', booking_date = '') => {
    this.setState({
      isLoadingCompanies: true,
      companyList: [],
      eventList: [],
      company_id: '',
      event_id: '',
    })

    try {
      const params = { keyword }
      if (booking_date) {
        params.booking_date = booking_date
      }

      const response = await axios.get(
        `${Constant.getAPI()}/event-companies/event-companies-v2/${this.BOOKING_TYPE}/${category_id}`,
        {
          headers: this.getHeaders(),
          params: params,
        }
      )

      if (response.data.success) {
        const companies = response.data.data?.filter((comp) => comp.is_active === true) || []

        this.setState(
          {
            companyList: companies,
            company_id: companies[0]?.id || '',
            isLoadingCompanies: false,
          },
          () => {
            if (companies.length > 0 && companies[0]?.id) {
              this.loadEvents(companies[0].id, category_id, keyword, booking_date)
            } else if (companies.length === 0) {
              this.showInfoMessage('No active companies found for this category')
            }
          }
        )
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingCompanies: false })
    }
  }

  loadEvents = async (company_id, category_id, keyword = '', booking_date = '') => {
    this.setState({
      isLoadingEvents: true,
      eventList: [],
      event_id: '',
      available_timeslots: [],
    })

    try {
      const params = { keyword }
      if (booking_date) {
        params.booking_date = booking_date
      }

      const response = await axios.get(
        `${Constant.getAPI()}/event/list-company-events-v2/${this.BOOKING_TYPE}/${company_id}/${category_id}`,
        {
          headers: this.getHeaders(),
          params: params,
        }
      )

      if (response.data.success) {
        const events = response.data.data || []

        this.setState(
          {
            eventList: events,
            event_id: events[0]?.id || '',
            category_id: category_id,
            isLoadingEvents: false,
          },
          () => {
            if (events.length > 0 && events[0]?.id) {
              this.loadCalendarData()
              this.loadEventDetails()
            } else if (events.length === 0) {
              this.showInfoMessage('No Kashta events found for this company')
            }
          }
        )
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingEvents: false })
    }
  }

  loadCalendarData = async () => {
    if (!this.state.event_id) {
      return
    }

    this.setState({
      isLoadingCalendar: true,
      available_timeslots: [],
      totalTickets: 1,
    })

    try {
      const response = await axios.post(
        `${Constant.getAPI()}/event/monthly-calendar?isB2B=${this.state.enable_b2b_prices}`,
        {
          date: moment(this.state.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          event_id: this.state.event_id,
        },
        { headers: this.getHeaders() }
      )

      if (response.data.success) {
        const slotList = response.data?.data || []
        const dateSlotObj = {}

        slotList.forEach((item) => {
          dateSlotObj[`date-${parseInt(moment(item.event_date).format('DD'))}`] = {
            enable: true,
          }
        })

        this.setState(
          {
            slots: slotList,
            calendarDateCellStatus: dateSlotObj,
            calendarData: response.data?.data,
          },
          () => {
            if (slotList.length > 0) {
              const firstSlotDate = moment(slotList[0]?.event_date, 'YYYY-MM-DD')
              const firstDate = parseInt(firstSlotDate.format('DD'))

              // Update calendarDate to the month of the first available slot
              const firstSlotMonth = firstSlotDate.startOf('month').format('YYYY-MM-DD')
              if (this.state.calendarDate !== firstSlotMonth) {
                this.setState({ calendarDate: firstSlotMonth }, () => {
                  this.selectCalendarDate(firstDate)
                })
              } else {
                this.selectCalendarDate(firstDate)
              }
            }
          }
        )
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingCalendar: false })
    }
  }

  loadEventDetails = async () => {
    if (!this.state.event_id) {
      return
    }

    try {
      const response = await axios.get(
        `${Constant.getAPI()}/event/event-details/${this.state.event_id}?isB2B=${this.state.enable_b2b_prices}`,
        { headers: this.getHeaders() }
      )

      if (response.data.success) {
        const eventData = response.data.data
        this.setState({
          adultTicketPrice: eventData.amount || 0,
          childTicketPrice: eventData.child_amount || 0,
          minTicketCount: eventData.min_tickets || 0,
          maxTicketCount: eventData.max_tickets || 0,
          adultTicketCount: 1,
          childTicketCount: 0,
          is_tickets_hide: eventData.is_tickets_hide || false,
        })
      }
    } catch (error) {
      this.handleApiError(error)
    }
  }

  showEventDetails = async (eventId) => {
    this.setState({ isLoadingEventDetails: true, showDetailsModal: true })

    try {
      const response = await axios.get(
        `${Constant.getAPI()}/event/event-details/${eventId}?isB2B=${this.state.enable_b2b_prices}`,
        { headers: this.getHeaders() }
      )

      if (response.data.success) {
        this.setState({ eventDetails: response.data.data })
      }
    } catch (error) {
      this.handleApiError(error)
      this.setState({ showDetailsModal: false })
    } finally {
      this.setState({ isLoadingEventDetails: false })
    }
  }

  closeEventDetails = () => {
    this.setState({ showDetailsModal: false, eventDetails: null })
  }

  // ==================== Booking Methods ====================

  handleBooking = async () => {
    // Validation
    if (!this.validateBookingForm()) {
      return
    }

    const bookingPayload = {
      phone: this.state.phone,
      email: this.state.email,
      country_code: this.state.country_code,
      event_id: this.state.event_id,
      slot_id: this.state.slot_id,
      ticket_count: this.state.adultTicketCount,
      child_ticket_count: this.state.childTicketCount,
      coupon_id: this.state.coupon_id || '',
      cost_of_service: this.state.cost_of_service,
      isB2B: this.state.enable_b2b_prices,
    }

    this.setState({ isData: true, isBooking: true })

    try {
      const response = await axios.post(`${Constant.getAPI()}/booking/admin-event-book`, bookingPayload, {
        headers: this.getHeaders(),
      })

      if (response.data.success) {
        this.setState({ bookingData: response.data.data }, () => {
          // Check if addons are available
          if (response.data.data.storeTypes && response.data.data.storeTypes.length > 0) {
            let tabArray = []
            for (let item of response.data.data.storeTypes) {
              // For event flow, only show CATERING if it has catering: true
              if (item.isAvailable) {
                // Only include CATERING type if it has catering enabled
                // if (item.id === 'CATERING' && !item.catering) {
                //   continue
                // }
                tabArray.push(item)
              }
            }
            if (tabArray.length > 0) {
              this.setState({
                appOnData: {
                  id: response.data.data.id,
                  event_id: response.data.data.event_id,
                  slot_id: this.state.slot_id,
                  event_data: response.data.data.event,
                  tab: tabArray,
                  enable_b2b_prices: this.state.enable_b2b_prices,
                  // Booking form data for checkout API
                  bookingPayload: {
                    phone: this.state.phone,
                    email: this.state.email,
                    country_code: this.state.country_code,
                    ticket_count: this.state.adultTicketCount,
                    child_ticket_count: this.state.childTicketCount,
                    coupon_id: this.state.coupon_id || '',
                    cost_of_service: this.state.cost_of_service,
                    isB2B: this.state.enable_b2b_prices,
                  },
                },
                addOnPopUp: 1,
              })
            } else {
              this.showPaymentConfirmation()
            }
          } else {
            this.showPaymentConfirmation()
          }
        })
      } else {
        Swal.fire({
          title: response.data.message || 'Booking failed. Please try again.',
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isData: false, isBooking: false })
    }
  }

  processPayment = async () => {
    this.setState({ isBooking: true })

    try {
      const response = await axios.post(
        `${Constant.getAPI()}/booking/process-event-payment`,
        {
          user_id: this.state.bookingData?.user_id,
          event_id: this.state.bookingData?.event_id,
          slot_id: this.state.bookingData?.slot_id,
          DisplayCurrencyIso: this.state.bookingData?.currency,
          ticket_count: this.state.adultTicketCount,
          child_ticket_count: this.state.childTicketCount,
          coupon_id: this.state.bookingData?.coupon_id,
          cost_of_service: this.state.bookingData?.cost_of_service,
          isB2B: this.state.enable_b2b_prices,
        },
        { headers: this.getHeaders() }
      )

      if (response?.data?.success) {
        Swal.fire({
          title: 'Booking Successful!',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'View Booking Details',
        }).then(() => {
          window.location.href = `#/new-evt/${response?.data?.data?.booking_id}`
        })
        this.resetForm()
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isBooking: false })
    }
  }

  // ==================== Coupon Methods ====================

  validateCoupon = async () => {
    if (!this.state.coupon.trim()) {
      Swal.fire('Coupon code required!', '', 'error')
      return
    }

    this.setState({ isLoading: true, isCustomerOptional: false, coupon_id: '' })

    try {
      const response = await axios.post(
        `${Constant.getAPI()}/booking/verify-coupon`,
        {
          cruise_id: this.state.event_id,
          booking_date: moment(this.state.date, 'YYYY-MM-DD').format('YYYY/MM/DD'),
          coupon: this.state.coupon,
        },
        { headers: this.getHeaders() }
      )

      if (response.data.success) {
        const couponData = response.data.data
        const isFullDiscount = couponData.amount_type === 'PERCENTAGE' && couponData.coupon_amount === 100

        this.setState({
          isCouponApplied: true,
          coupon_id: couponData.id,
          isCustomerOptional: isFullDiscount,
        })

        Swal.fire(response.data.message, '', 'success')
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  removeCoupon = () => {
    this.setState({
      coupon: '',
      isCouponApplied: false,
      isCustomerOptional: false,
      coupon_id: '',
    })
  }

  // ==================== Calendar Methods ====================

  selectCalendarDate = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')

    if (!date || moment(date).isBefore(moment().subtract(1, 'day')) || this.calendarCell(day, 'E')) {
      return
    }

    // Normalize date format for comparison
    const normalizedDate = moment(date).format('YYYY-MM-DD')
    const slotData = this.state.slots.find((slot) => {
      const slotDate = moment(slot.event_date).format('YYYY-MM-DD')
      return slotDate === normalizedDate
    })

    if (slotData?.available_timeslots?.length > 0) {
      const firstSlot = slotData.available_timeslots[0]
      this.setState(
        {
          available_timeslots: slotData.available_timeslots,
          selected_slot: `${moment(firstSlot.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(firstSlot.end_time, 'HH:mm:ss').format('hh:mm A')}`,
          slot_id: firstSlot.id,
          date: date,
          totalTickets: firstSlot.ticket_count || 1,
        },
        () => {
          this.calendarDateColor(day)
        }
      )
    }
  }

  changeCalendarMonth = (forward) => {
    const newDate = moment(this.state.calendarDate)
      .add(forward ? 1 : -1, 'month')
      .format('YYYY-MM-DD')

    const selectedDate =
      moment().startOf('M').format('YYYY-MM-DD') === moment(newDate).startOf('M').format('YYYY-MM-DD')
        ? moment().format('YYYY-MM-DD')
        : moment(newDate).format('YYYY-MM-DD')

    this.setState(
      {
        calendarDate: newDate,
        date: selectedDate,
      },
      () => {
        this.loadCalendarData()
      }
    )
  }

  calendarDateColor = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')

    if (date === this.state.date && this.state.slots.length > 0) {
      return 'select-blue'
    }

    if (moment(date).isBefore(moment().subtract(1, 'day'))) {
      return 'month-date'
    }

    const availableDate = this.state.slots.find((slot) => slot.event_date === date && slot.available === true)

    return availableDate ? 'light-blue' : 'month-date'
  }

  calendarCell = (day, type) => {
    const cellKey = `date-${day}`
    const cellStatus = this.state.calendarDateCellStatus[cellKey]

    if (!cellStatus) return false

    if (type === 'P' && cellStatus.price) {
      return `${cellStatus.price} ${getCurrency(localStorage.getItem('countryShortName'))}`
    }

    if (type === 'E') {
      return !cellStatus.enable
    }

    return false
  }

  // ==================== Ticket Methods ====================

  incrementAdultTicket = () => {
    const newTotal = this.state.adultTicketCount + this.state.childTicketCount + 1
    if (newTotal > this.state.maxTicketCount || newTotal > this.state.totalTickets) {
      Swal.fire('Maximum tickets reached for this day!', '', 'error')
      return
    }
    this.setState((prev) => ({ adultTicketCount: prev.adultTicketCount + 1 }))
  }

  decrementAdultTicket = () => {
    if (this.state.adultTicketCount <= this.state.minTicketCount) {
      Swal.fire('Minimum ticket requirement not met!', '', 'error')
      return
    }
    if (this.state.adultTicketCount > 0) {
      this.setState((prev) => ({ adultTicketCount: prev.adultTicketCount - 1 }))
    }
  }

  incrementChildTicket = () => {
    const newTotal = this.state.adultTicketCount + this.state.childTicketCount + 1
    if (newTotal > this.state.maxTicketCount || newTotal > this.state.totalTickets) {
      Swal.fire('Maximum tickets reached for this day!', '', 'error')
      return
    }
    this.setState((prev) => ({ childTicketCount: prev.childTicketCount + 1 }))
  }

  decrementChildTicket = () => {
    if (this.state.childTicketCount > 0) {
      this.setState((prev) => ({ childTicketCount: prev.childTicketCount - 1 }))
    }
  }

  selectTimeSlot = (slotId) => {
    const slot = this.state.available_timeslots.find((s) => s.id === slotId)
    if (slot) {
      this.setState({
        slot_id: slotId,
        totalTickets: slot.ticket_count > 0 ? slot.ticket_count : 1,
        selected_slot: `${moment(slot.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(slot.end_time, 'HH:mm:ss').format('hh:mm A')}`,
        timeSlotDrop: false,
      })
    }
  }

  // ==================== Helper Methods ====================

  // Email validation helper
  isValidEmail = (email) => {
    if (!email) return true // Empty is valid (optional field)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  handleChange = (event) => {
    const { name, value, checked, type } = event.target
    const newValue = type === 'checkbox' ? checked : value

    this.setState({ [name]: newValue }, () => {
      if (name === 'category_id') {
        this.setState({ company_search: '' })
        this.loadCompanies(value)
      } else if (name === 'enable_b2b_prices') {
        this.resetForm()
        this.loadCategories()
      } else if (name === 'cost_of_service' && parseFloat(value) < 0) {
        this.setState({ cost_of_service: 0 })
      } else if (name === 'email') {
        // Validate email on change
        if (value && !this.isValidEmail(value)) {
          this.setState({ emailError: 'Please enter a valid email address' })
        } else {
          this.setState({ emailError: '' })
        }
      } else if (name === 'company_search') {
        // Debounce search API call
        if (this.searchDebounceTimer) {
          clearTimeout(this.searchDebounceTimer)
        }

        this.searchDebounceTimer = setTimeout(() => {
          this.loadCategories(value, this.state.booking_date)
        }, 500)
      }
    })
  }

  updateFilterCount = () => {
    let count = 0
    if (this.state.booking_date) {
      count = count + 1
    }
    this.setState({
      filterCount: count,
    })
  }

  applyFilter = async (value) => {
    this.setState({ filterOpen: !this.state.filterOpen })
    if (!value) {
      await this.setState({
        booking_date: '',
      })
    }

    // Call API with or without filter
    await this.loadCategories(this.state.company_search, value ? this.state.booking_date : '')

    // Update filter count
    this.updateFilterCount()
  }

  onBookingDateChange = (event) => {
    const selectedDate = event.target.value
    this.setState(
      {
        booking_date: moment(selectedDate).format('YYYY-MM-DD'),
      },
      () => {
        this.updateFilterCount()
      }
    )
  }

  validateBookingForm = () => {
    if (!this.state.event_id) {
      Swal.fire('Please select a Kashta event!', '', 'error')
      return false
    }
    if (!this.state.date) {
      Swal.fire('Please select a date!', '', 'error')
      return false
    }
    if (!this.state.slot_id) {
      Swal.fire('Please select a time slot!', '', 'error')
      return false
    }

    // Check if customer number is required
    // Customer number is NOT required if coupon is applied and total amount is zero
    const isCouponAppliedWithZeroAmount =
      this.state.isCouponApplied && this.state.bookingData?.total_booking_amount === 0

    if (!this.state.isCustomerOptional && !isCouponAppliedWithZeroAmount) {
      if (!this.state.country_code) {
        Swal.fire('Country code is required!', '', 'error')
        return false
      }
      if (!this.state.phone) {
        Swal.fire('Customer number is required!', '', 'error')
        return false
      }
    }

    // Validate email format if provided
    if (this.state.email && !this.isValidEmail(this.state.email)) {
      Swal.fire('Please enter a valid email address!', '', 'error')
      return false
    }

    return true
  }

  resetForm = () => {
    this.setState({
      phone: '',
      email: '',
      coupon: '',
      country_code: '',
      cost_of_service: 0,
      isCustomerOptional: false,
      isCouponApplied: false,
      childTicketCount: 0,
      adultTicketCount: 1,
      childTicketPrice: 0,
      adultTicketPrice: 0,
      minTicketCount: 0,
      maxTicketCount: 0,
      totalTickets: 1,
      coupon_id: '',
      addOnPopUp: 0,
      appOnData: {},
      company_search: '',
      booking_date: '',
      filterCount: 0,
    })
  }

  getHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
    country_short_name: `${localStorage.getItem('countryShortName')}`,
  })

  handleApiError = (error) => {
    if (error?.response?.status === 401) {
      Constant.getAuthLogout()
    } else {
      const errorMessage =
        error?.response?.data?.data?.details?.[0]?.message ||
        error?.response?.data?.message ||
        'An error occurred. Please try again.'
      Swal.fire({
        title: errorMessage,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
      })
    }
  }

  showInfoMessage = (message) => {
    Swal.fire({
      title: message,
      icon: 'info',
      confirmButtonText: 'Ok',
    })
  }

  onCheckout = async (data) => {
    this.setState({ isData: true, isLoading: true })

    await axios
      .post(Constant.getAPI() + '/booking/admin-event-checkout', data, {
        headers: this.getHeaders(),
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            bookingData: res.data.data,
          })
          // Check if addons are still available after checkout
          if (res.data.data.storeTypes && res.data.data.storeTypes.length > 0) {
            let tabArray = []
            for (let item of res.data.data.storeTypes) {
              // For event flow, only show CATERING if it has catering: true
              if (item.isAvailable) {
                // Only include CATERING type if it has catering enabled
                if (item.id === 'CATERING' && !item.catering) {
                  continue
                }
                tabArray.push(item)
              }
            }
            if (tabArray.length > 0) {
              this.setState({
                appOnData: {
                  id: res.data.data.id,
                  event_id: res.data.data.event_id,
                  slot_id: this.state.slot_id,
                  event_data: res.data.data.event,
                  tab: tabArray,
                  enable_b2b_prices: this.state.enable_b2b_prices,
                  // Booking form data for checkout API
                  bookingPayload: {
                    phone: this.state.phone,
                    email: this.state.email,
                    country_code: this.state.country_code,
                    ticket_count: this.state.adultTicketCount,
                    child_ticket_count: this.state.childTicketCount,
                    coupon_id: this.state.coupon_id || '',
                    cost_of_service: this.state.cost_of_service,
                    isB2B: this.state.enable_b2b_prices,
                  },
                },
                addOnPopUp: 1,
              })
            } else {
              this.showPaymentConfirmation()
            }
          } else {
            this.showPaymentConfirmation()
          }
        }
      })
      .catch((error) => {
        this.handleApiError(error)
      })
      .finally(() => {
        this.setState({
          isData: false,
          isLoading: false,
        })
      })
  }

  handleDataFromChild = (data) => {
    this.setState({ addOnPopUp: 0 })
    this.onCheckout(data)
  }

  showPaymentConfirmation = () => {
    this.setState({ showPaymentModal: true })
  }

  closePaymentModal = () => {
    this.setState({ showPaymentModal: false })
  }

  renderPaymentConfirmationModal = () => {
    if (!this.state.showPaymentModal) return null

    const { bookingData } = this.state
    const currency = getCurrency(localStorage.getItem('countryShortName'))
    const eventDate = bookingData?.event_date
      ? moment(bookingData.event_date, 'YYYY-MM-DD').format('dddd, D MMMM')
      : '--'

    return (
      <div className="App">
        <div
          className="popup-backdrop"
          onClick={this.closePaymentModal}
        >
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: '600px',
              padding: '25px',
              position: 'relative',
              maxHeight: '90vh',
              overflow: 'auto',
            }}
          >
            {/* Close Button */}
            <button
              className="popup-close"
              onClick={this.closePaymentModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 1000,
              }}
            >
              <img
                src="./assets/icon/concierge/close-black.svg"
                alt="Close"
              />
            </button>

            {/* Header */}
            <h2
              style={{ margin: '0 0 20px 0', fontSize: '20px', fontWeight: '600', color: '#333', textAlign: 'center' }}
            >
              Payment Confirmation
            </h2>

            {/* Event Info Card */}
            <div
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '15px 20px',
                marginBottom: '20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ textAlign: 'left' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#666' }}>From</p>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#00547e' }}>{eventDate}</p>
                <span style={{ fontSize: '13px', color: '#00547e' }}>{bookingData?.start_time || ''}</span>
              </div>
              <div style={{ textAlign: 'center' }}>
                {this.state.bookingData?.event_image && (
                  <img
                    src={Constant.getImage() + this.state.bookingData?.event_image}
                    alt={this.state.bookingData?.event_name || this.state.title}
                    style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                    }}
                  />
                )}
                <h5 style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#00547e' }}>
                  {bookingData?.event_name || '--'}
                </h5>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#666' }}>To</p>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#00547e' }}>{eventDate}</p>
                <span style={{ fontSize: '13px', color: '#00547e' }}>{bookingData?.end_time || ''}</span>
              </div>
            </div>

            {/* Payment Summary Card */}
            <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 20px 0', fontSize: '16px', fontWeight: '600', color: '#333' }}>
                Payment Summary
              </h3>

              {/* Event Amount */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Event Amount</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.event_amount || 0} {currency}
                </span>
              </div>

              {/* Cost Of Service */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Cost Of Service</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.cost_of_service || 0} {currency}
                </span>
              </div>

              {/* Coupon Applied Amount */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Coupon Applied Amount</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.coupon_applied_amount || 0} {currency}
                </span>
              </div>

              {/* VAT */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>VAT ({bookingData?.vat_per || 0}%)</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.vat || 0} {currency}
                </span>
              </div>

              {/* Total */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '15px 0 0 0',
                }}
              >
                <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>Total</p>
                <span style={{ fontSize: '16px', fontWeight: '700', color: '#00547e' }}>
                  {bookingData?.total_booking_amount || 0} {currency}
                </span>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
              <button
                onClick={this.closePaymentModal}
                style={{
                  flex: 1,
                  padding: '12px',
                  backgroundColor: '#fff',
                  color: '#d33',
                  border: '1px solid #d33',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  this.closePaymentModal()
                  this.processPayment()
                }}
                disabled={this.state.isBooking}
                style={{
                  flex: 2,
                  padding: '12px',
                  backgroundColor: this.state.isBooking ? '#6c9ab5' : '#00547e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: this.state.isBooking ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
              >
                {this.state.isBooking && (
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      border: '2px solid #fff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                    }}
                  />
                )}
                {this.state.isBooking
                  ? 'Processing...'
                  : `Process Payment ${bookingData?.total_booking_amount || 0} ${currency}`}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // ==================== Render Methods ====================

  renderB2BToggle = () => {
    if (localStorage['user_role'] != 'concierge') {
      return (
        <div style={{ borderBottom: '1px solid #ddd', marginBottom: 10 }}>
          <div className="col-md-6">
            <div className="form-group row">
              <label className="col-3 text-heading p-0">Enable B2B Prices</label>
              <div className="col-4">
                <Toggle
                  className="ml-2 form-control"
                  name="enable_b2b_prices"
                  id="enable_b2b_prices"
                  icons={false}
                  onChange={this.handleChange}
                  checked={this.state.enable_b2b_prices}
                />
              </div>
            </div>
          </div>
        </div>
      )
    }
    return null
  }

  renderSelectionGrid = (items, selectedId, onSelect, title, emptyMessage, showViewIcon = false) => {
    if (items.length === 0) {
      const iconType = title === 'Companies' ? 'company' : 'event'
      return this.renderEmptyState(
        iconType,
        emptyMessage,
        title === 'Companies' ? 'Please select a different category' : 'Please select a different company'
      )
    }

    return (
      <div className="category-data mt-3">
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              ...this.customStyle.listBox,
              ...(selectedId === item.id ? this.customStyle.listBoxSelected : {}),
              position: 'relative',
            }}
          >
            <div
              onClick={() => onSelect(item)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  item.category_img_url || item.banner_img || item.event_image
                    ? `${Constant.getImage()}${item.category_img_url || item.banner_img || item.event_image}`
                    : './assets/images/no_image.png'
                }
                alt={item.category_name_en || item.company_name || item.event_name}
                onError={(e) => {
                  e.target.src = './assets/images/no_image.png'
                }}
                style={this.customStyle.listBoxImage}
              />
              {title === 'Companies' || title === 'Categories' ? (
                <p style={this.customStyle.listBoxLabel}>
                  {item.category_name_en ||
                    item.company_name ||
                    item.company_name_en ||
                    item.company_short_name_en ||
                    item.company_short_name ||
                    item.event_name}
                </p>
              ) : (
                <>
                  <h4 className="m-0 head-name">
                    {item.event_name || item.company_name || item.category_name_en}
                  </h4>
                  <p className="m-0 price-data">
                    Starting from {item.amount || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                  </p>
                </>
              )}
            </div>
            {showViewIcon && (
              <div
                style={{
                  position: 'absolute',
                  top: 5,
                  right: 5,
                  cursor: 'pointer',
                  background: '#00547e',
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  this.showEventDetails(item.id)
                }}
                title="View Details"
              >
                <i
                  className="icofont icofont-eye"
                  style={{ color: 'white', fontSize: '16px' }}
                ></i>
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  getDatePrice = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')
    const slot = this.state.slots.find((s) => s.event_date === date && s.available === true)
    return slot ? slot.amount : null
  }

  renderCalendar = () => {
    const canGoBack = moment(this.state.calendarDate).isAfter(moment().startOf('month'), 'month')

    return (
      <div className="booking-box mt-3">
        <div className="month-cal">
          {canGoBack ? (
            <div
              onClick={() => this.changeCalendarMonth(false)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src="./assets/icon/concierge/arrow-prev.svg"
                alt="Previous"
              />
            </div>
          ) : (
            <div></div>
          )}
          <div className="day">{moment(this.state.calendarDate).format('MMMM, YYYY')}</div>
          <div
            onClick={() => this.changeCalendarMonth(true)}
            style={{ cursor: 'pointer' }}
          >
            <img
              src="./assets/icon/concierge/arrow-next.svg"
              alt="Next"
            />
          </div>
        </div>
        <div className="day-list mt-3">
          {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((day) => (
            <span
              key={day}
              className="day-all"
            >
              {day}
            </span>
          ))}
        </div>
        <div className="mt-3 month-data">
          {Array.from({ length: moment(this.state.calendarDate).day() }).map((_, i) => (
            <span key={`empty-${i}`}></span>
          ))}
          {Array.from({ length: moment(this.state.calendarDate).daysInMonth() }).map((_, i) => {
            const price = this.getDatePrice(i + 1)
            const isSelected = this.calendarDateColor(i + 1) === 'select-blue'
            return (
              <span
                key={i}
                className={`${this.calendarDateColor(i + 1)} month-date`}
                onClick={() => this.selectCalendarDate(i + 1)}
              >
                <div>{i + 1}</div>
                {price && (
                  <div style={{ fontSize: '10px', fontWeight: '600', color: isSelected ? '#fff' : '#00547e' }}>
                    {price} {getCurrency(localStorage.getItem('countryShortName'))}
                  </div>
                )}
              </span>
            )
          })}
        </div>
      </div>
    )
  }

  renderTimeSlotSelector = () => {
    if (this.state.available_timeslots.length === 0) {
      return this.renderEmptyState('time', 'No time slots available', 'Please select a different date')
    }

    return (
      <div className="position-relative mt-3">
        <div onClick={() => this.setState({ timeSlotDrop: !this.state.timeSlotDrop })}>
          <div className="collapsed card-shadow p-3 d-flex justify-content-between align-items-center rounded">
            <div className="d-flex gap-10 align-items-center">
              <div className="location-icon">
                <img
                  src="./assets/icon/concierge/location-new.svg"
                  alt=""
                />
              </div>
              <div className="location-in">
                <h3 className="m-0">{this.state.selected_slot || 'Select time slot'}</h3>
              </div>
            </div>
            <div className="arrow">
              <img
                src="./assets/icon/concierge/arrow-up.svg"
                alt=""
              />
            </div>
          </div>
        </div>
        {this.state.timeSlotDrop && (
          <div className="destination p-3 card-shadow">
            {this.state.available_timeslots.map((slot) => (
              <div
                key={slot.id}
                className={`destination-data ${slot.id === this.state.slot_id ? 'destination-select' : ''}`}
                onClick={() => this.selectTimeSlot(slot.id)}
              >
                <div className="d-flex justify-content-between align-items-center gap-10">
                  <h1 className="m-0">
                    {moment(slot.start_time, 'HH:mm:ss').format('hh:mm A')} -{' '}
                    {moment(slot.end_time, 'HH:mm:ss').format('hh:mm A')}
                  </h1>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  renderTicketCounter = (type, count, price, increment, decrement) => {
    const currency = getCurrency(localStorage.getItem('countryShortName'))
    const totalPrice = price * count

    return (
      <div className="counter-container">
        <div className="counter-label">{type}</div>
        <div className="counter-buttons">
          <button
            className="counter-button decrement"
            onClick={decrement}
          >
            -
          </button>
          <div className="count">{count}</div>
          <button
            className="counter-button increment"
            onClick={increment}
          >
            +
          </button>
        </div>
        <div className="priceE">
          {totalPrice} {currency}
        </div>
      </div>
    )
  }

  renderEventDetailsModal = () => {
    if (!this.state.showDetailsModal) return null

    // Show loader while loading event details
    if (this.state.isLoadingEventDetails) {
      return (
        <div className="App">
          <div
            className="popup-backdrop"
            onClick={this.closeEventDetails}
          >
            <div
              className="popup-content"
              onClick={(e) => e.stopPropagation()}
              style={{
                width: '90%',
                maxWidth: '600px',
                padding: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {this.renderInlineLoader(150)}
            </div>
          </div>
        </div>
      )
    }

    if (!this.state.eventDetails) return null

    const details = this.state.eventDetails

    // Get all images from gallery
    const images = []
    if (details.event_image) images.push(details.event_image)
    if (details.event_image_ar) images.push(details.event_image_ar)
    if (details.event_gallery && Array.isArray(details.event_gallery) && details.event_gallery.length > 0) {
      // Add gallery images
      details.event_gallery.forEach((galleryItem) => {
        if (galleryItem.gal_large_img) {
          images.push(galleryItem.gal_large_img)
        }
      })
    }
    if (details.event_images && Array.isArray(details.event_images)) {
      images.push(...details.event_images)
    }

    return (
      <div className="App">
        <div
          className="popup-backdrop"
          onClick={this.closeEventDetails}
        >
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: '1200px',
              maxHeight: '90vh',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              padding: '25px',
              position: 'relative',
            }}
          >
            <button
              className="popup-close"
              onClick={this.closeEventDetails}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 1000,
                background: 'white',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              }}
            >
              <img
                src="./assets/icon/concierge/close-black.svg"
                alt="Close"
              />
            </button>
            <div
              style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                maxHeight: 'calc(90vh - 100px)',
                width: '100%',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
              className="scroll"
            >
              <div
                className="popup-data"
                style={{
                  width: '100%',
                  display: 'flex',
                  gap: '30px',
                }}
              >
                {/* Images Section */}
                {images.length > 0 && (
                  <div
                    className="w-50"
                    style={{
                      paddingRight: '20px',
                      maxHeight: 'calc(90vh - 50px)',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                    }}
                  >
                    <div className="slider-container img-250">
                      {images.length === 1 ? (
                        <img
                          src={`${Constant.getImage()}${images[0]}`}
                          alt={details.event_name_en || details.event_name}
                          style={{
                            width: '100%',
                            maxHeight: '400px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                          }}
                          onError={(e) => {
                            e.target.src = './assets/images/no_image.png'
                          }}
                        />
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                          {images.map((img, index) => (
                            <img
                              key={index}
                              src={`${Constant.getImage()}${img}`}
                              alt={`${details.event_name_en || details.event_name} - ${index + 1}`}
                              style={{
                                width: '100%',
                                maxHeight: '300px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                              }}
                              onError={(e) => {
                                e.target.src = './assets/images/no_image.png'
                              }}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Details Section */}
                <div
                  className={images.length > 0 ? 'w-50' : 'w-100'}
                  style={{
                    maxHeight: 'calc(90vh - 50px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  <div>
                    <h3
                      className="m-0"
                      style={{ marginBottom: '15px', color: '#00547e' }}
                    >
                      {details.event_name_en || details.event_name || 'Event Details'}
                    </h3>

                    {details.event_name_ar && (
                      <h4 style={{ marginBottom: '15px', color: '#666' }}>{details.event_name_ar}</h4>
                    )}

                    {/* Description */}
                    {(details.event_desc || details.event_desc_en || details.event_desc_ar) && (
                      <div style={{ marginBottom: '20px' }}>
                        <h5 style={{ color: '#00547e', marginBottom: '10px' }}>Description</h5>
                        <div
                          className="review-location"
                          style={{
                            height: 'auto',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            lineHeight: '20px',
                            fontSize: '14px',
                            color: '#333',
                            padding: '10px',
                            background: '#f5f5f5',
                            borderRadius: '5px',
                          }}
                        >
                          {details.event_desc && (
                            <div
                              style={{ marginBottom: details.event_desc_en || details.event_desc_ar ? '10px' : '0' }}
                            >
                              <div dangerouslySetInnerHTML={{ __html: details.event_desc }} />
                            </div>
                          )}
                          {details.event_desc_en && (
                            <div style={{ marginBottom: details.event_desc_ar ? '10px' : '0' }}>
                              <strong>English:</strong>
                              <div dangerouslySetInnerHTML={{ __html: details.event_desc_en }} />
                            </div>
                          )}
                          {details.event_desc_ar && (
                            <div>
                              <strong>Arabic:</strong>
                              <div dangerouslySetInnerHTML={{ __html: details.event_desc_ar }} />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Restaurant Board List / Amenities */}
                    {details.restaurant_board_list && (
                      <div style={{ marginBottom: '20px' }}>
                        <h5 style={{ color: '#00547e', marginBottom: '10px' }}>Amenities & Features</h5>
                        <div
                          style={{
                            height: 'auto',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            lineHeight: '20px',
                            fontSize: '14px',
                            color: '#333',
                            padding: '10px',
                            background: '#f5f5f5',
                            borderRadius: '5px',
                          }}
                          dangerouslySetInnerHTML={{ __html: details.restaurant_board_list }}
                        />
                      </div>
                    )}

                    {/* Pickup Details */}
                    {details.pickUp_details && (
                      <div style={{ marginBottom: '20px' }}>
                        <h5 style={{ color: '#00547e', marginBottom: '10px' }}>Pickup Location</h5>
                        <div
                          style={{
                            padding: '10px',
                            background: '#f5f5f5',
                            borderRadius: '5px',
                            fontSize: '14px',
                          }}
                        >
                          {details.pickUp_details.pickup_desc && (
                            <div style={{ marginBottom: '8px' }}>
                              <strong>Location:</strong> {details.pickUp_details.pickup_desc}
                            </div>
                          )}
                          {(details.pickUp_details.pickup_lat || details.pickUp_details.pickup_long) && (
                            <div style={{ marginBottom: '8px' }}>
                              <strong>Coordinates:</strong>{' '}
                              {details.pickUp_details.pickup_lat && `Lat: ${details.pickUp_details.pickup_lat}`}
                              {details.pickUp_details.pickup_lat && details.pickUp_details.pickup_long && ', '}
                              {details.pickUp_details.pickup_long && `Long: ${details.pickUp_details.pickup_long}`}
                            </div>
                          )}
                          {details.pickUp_details.pickup_address && (
                            <div>
                              <strong>Address:</strong> {details.pickUp_details.pickup_address}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Video URL */}
                    {details.video_url && (
                      <div style={{ marginBottom: '20px' }}>
                        <h5 style={{ color: '#00547e', marginBottom: '10px' }}>Video</h5>
                        <div style={{ width: '100%', maxWidth: '100%' }}>
                          <video
                            style={{ border: '1px solid #ddd', borderRadius: '5px' }}
                            width="100%"
                            height="250"
                            controls
                            src={`${Constant.getImage()}${details.video_url}`}
                            title={`${details.event_name_en || details.event_name} Video`}
                          ></video>
                        </div>
                      </div>
                    )}

                    {/* Additional Information */}
                    <div style={{ marginBottom: '15px' }}>
                      <h5 style={{ color: '#00547e', marginBottom: '10px' }}>Additional Information</h5>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px' }}>
                        {details.event_start_date && (
                          <div>
                            <strong>Start Date:</strong> {moment(details.event_start_date).format('MMMM DD, YYYY')}
                          </div>
                        )}
                        {details.minimum_booking_time && (
                          <div>
                            <strong>Minimum Booking Time:</strong> {details.minimum_booking_time} hours
                          </div>
                        )}
                        {details.is_catering_available !== undefined && (
                          <div>
                            <strong>Catering Available:</strong>{' '}
                            {details.is_catering_available ? (
                              <span style={{ color: 'green' }}>Yes</span>
                            ) : (
                              <span style={{ color: 'red' }}>No</span>
                            )}
                          </div>
                        )}
                        {details.pickup_id && (
                          <div>
                            <strong>Pickup Available:</strong> <span style={{ color: 'green' }}>Yes</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Company Image */}
                    {details.company_image && (
                      <div style={{ marginBottom: '15px' }}>
                        <h5 style={{ color: '#00547e', marginBottom: '10px' }}>Company Image</h5>
                        <img
                          src={`${Constant.getImage()}${details.company_image}`}
                          alt="Company"
                          style={{
                            width: '100%',
                            maxWidth: '200px',
                            height: 'auto',
                            borderRadius: '5px',
                            border: '1px solid #ddd',
                          }}
                          onError={(e) => {
                            e.target.src = './assets/images/no_image.png'
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { isLoading, initialLoading } = this.state
    const remainingTickets = this.state.totalTickets - this.state.childTicketCount - this.state.adultTicketCount

    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    {(isLoading || initialLoading) && (
                      <div className="loader-overlay">
                        <div className="loader"></div>
                      </div>
                    )}

                    {/* Page Title with B2B Toggle */}
                    <div
                      style={{
                        marginBottom: 25,
                        paddingBottom: 15,
                        border: '2px solid #00547e',
                        padding: '10px 20px',
                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        alignContent: 'center',
                      }}
                    >
                      <h1
                        style={{
                          fontSize: '26px',
                          fontWeight: '700',
                          color: '#00547e',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          margin: 0,
                        }}
                      >
                        <i
                          className="icofont icofont-calendar"
                          style={{ marginRight: '10px', fontSize: '28px' }}
                        ></i>
                        Kashta Booking
                      </h1>
                      {localStorage['user_role'] != 'concierge' && (
                        <div
                          style={{
                            display: 'flex',
                            width: '250px',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <label style={{ width: '150px', fontWeight: '600', marginBottom: 0 }}>
                            Enable B2B Prices
                          </label>
                          <Toggle
                            className="w-25"
                            name="enable_b2b_prices"
                            id="enable_b2b_prices"
                            icons={false}
                            onChange={this.handleChange}
                            checked={this.state.enable_b2b_prices}
                          />
                        </div>
                      )}
                    </div>

                    {/* Categories Section */}
                    <div className="card-padding mb-3">
                      <div className="yacht-title mb-1">
                        <h2 className="text-heading">Select Category</h2>
                        <div className="contact-in contact-second">
                          <div>
                            <input
                              type="text"
                              className="form-control"
                              name="company_search"
                              id="company_search"
                              placeholder="Search companies/events"
                              onChange={this.handleChange}
                              value={this.state.company_search}
                              style={{ borderRadius: '10px' }}
                            />
                          </div>
                          <div className="position-relative filter-width">
                            <div
                              className="filter"
                              onClick={() =>
                                this.setState({
                                  filterOpen: !this.state.filterOpen,
                                })
                              }
                            >
                              <img
                                src="./assets/icon/concierge/filter-icon.svg"
                                alt="Filter"
                              />
                              <p className="m-0">Filter</p>
                              {this.state.filterCount > 0 && (
                                <span className="filter-count-indicator">{this.state.filterCount}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.renderSelectionGrid(
                        this.state.categoryList,
                        this.state.category_id,
                        (category) => {
                          this.setState({
                            category_id: category.id,
                            company_id: '',
                            event_id: '',
                            companyList: [],
                            eventList: [],
                            available_timeslots: [],
                            slot_id: '',
                            selected_slot: '',
                            company_search: '',
                          })
                          this.loadCompanies(category.id, this.state.company_search, this.state.booking_date)
                        },
                        'Categories',
                        'No categories available',
                        false
                      )}
                    </div>

                    {/* Companies Section */}
                    {this.state.categoryList.length > 0 && this.state.category_id && (
                      <div className="card-padding mb-3">
                        <h2 className="text-heading">Select Company</h2>
                        {this.state.isLoadingCompanies
                          ? this.renderInlineLoader(120)
                          : this.renderSelectionGrid(
                            this.state.companyList,
                            this.state.company_id,
                            (company) => {
                              this.setState({ company_id: company.id })
                              this.loadEvents(company.id, this.state.category_id, this.state.company_search, this.state.booking_date)
                            },
                            'Companies',
                            'No companies available',
                            false
                          )}
                      </div>
                    )}

                    {/* Filter popup */}
                    {this.state.filterOpen && (
                      <div
                        className="popup-backdrop"
                        onClick={() =>
                          this.setState({
                            filterOpen: !this.state.filterOpen,
                          })
                        }
                      >
                        <div
                          className="popup-content filter-popup-content"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            className="popup-close"
                            onClick={() =>
                              this.setState({
                                filterOpen: !this.state.filterOpen,
                              })
                            }
                          >
                            <img
                              src="./assets/icon/concierge/close-black.svg"
                              alt="Close"
                            />
                          </button>
                          <div className="popupScroll">
                            <div className="filter-popup-header">
                              <div className="filter-icon-header">
                                <img
                                  src="./assets/icon/concierge/filter-icon.svg"
                                  alt="Filter"
                                  className="filter-main-icon"
                                />
                              </div>
                              <h2 className="text-heading filter-main-title">Filter Options</h2>
                              <p className="filter-subtitle">Refine your search to find the perfect company</p>
                            </div>

                            <div className="filter-sections">
                              {/* Booking Date Section */}
                              <div className="filter-section">
                                <div className="filter-section-header">
                                  <div className="filter-section-icon">
                                    <img
                                      src="./assets/icon/concierge/clock.svg"
                                      alt="Date"
                                      className="filter-icon"
                                    />
                                  </div>
                                  <div className="filter-section-info">
                                    <h3 className="filter-section-title">Booking Date</h3>
                                    <p className="filter-section-description">Select your preferred date</p>
                                  </div>
                                </div>
                                <div className="filter-section-content">
                                  <div className="date-input-wrapper">
                                    <input
                                      type="date"
                                      className="form-control date-input"
                                      name="booking_date_filter"
                                      id="booking_date_filter"
                                      value={this.state.booking_date}
                                      onChange={this.onBookingDateChange}
                                      min={moment().format('YYYY-MM-DD')}
                                      placeholder="Select date"
                                    />
                                    {this.state.booking_date && (
                                      <button
                                        className="clear-date-btn"
                                        onClick={() =>
                                          this.setState({ booking_date: '' }, () => this.updateFilterCount())
                                        }
                                        title="Clear date"
                                      >
                                        <img
                                          src="./assets/icon/concierge/close-black.svg"
                                          alt="Clear"
                                        />
                                      </button>
                                    )}
                                  </div>
                                  {this.state.booking_date && (
                                    <div className="filter-value-display">
                                      <span className="filter-value-label">Selected:</span>
                                      <span className="filter-value-text">
                                        {moment(this.state.booking_date).format('MMMM DD, YYYY')}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="filter-actions">
                              <button
                                type="button"
                                className="btn filter-reset-btn"
                                onClick={() => this.applyFilter(0)}
                                disabled={this.state.filterCount === 0}
                              >
                                <span className="btn-icon-text">↻</span>
                                Reset All
                              </button>
                              <button
                                type="button"
                                className="btn book-btn filter-apply-btn"
                                onClick={() => this.applyFilter(1)}
                              >
                                <span className="btn-icon-text">✓</span>
                                Apply Filters
                                {this.state.filterCount > 0 && (
                                  <span className="filter-count-badge">{this.state.filterCount}</span>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Events Section */}
                    {this.state.companyList.length > 0 && (
                      <div className="card-padding mb-3">
                        <h2 className="text-heading">Select Kashta Event</h2>
                        {this.state.isLoadingEvents
                          ? this.renderInlineLoader(120)
                          : this.renderSelectionGrid(
                            this.state.eventList,
                            this.state.event_id,
                            (event) => {
                              this.setState(
                                {
                                  event_id: event.id,
                                  available_timeslots: [],
                                  slot_id: '',
                                  selected_slot: '',
                                  date: moment().format('YYYY-MM-DD'),
                                  calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
                                  slots: [],
                                  calendarDateCellStatus: {},
                                },
                                () => {
                                  this.loadCalendarData()
                                  this.loadEventDetails()
                                }
                              )
                            },
                            'Events',
                            'No Kashta events available',
                            true // showViewIcon
                          )}
                      </div>
                    )}

                    {/* Booking Section */}
                    {this.state.categoryList.length > 0 && this.state.event_id && (
                      <div className="mt-20">
                        <div className="booking-data">
                          <div>
                            <h2 className="text-heading">Select Date</h2>
                            {this.state.isLoadingCalendar || this.state.isLoadingEvents
                              ? this.renderInlineLoader(200)
                              : this.renderCalendar()}
                          </div>

                          <div>
                            <h2 className="text-heading">Select Time</h2>
                            {this.renderTimeSlotSelector()}

                            {!this.state.is_tickets_hide && (
                              <div className="mt-3">
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <h2 className="text-heading">Number of Tickets</h2>
                                  <label className="col-form-label colformlabel">
                                    {remainingTickets} Tickets remaining
                                  </label>
                                </div>
                                {this.state.available_timeslots.length > 0 ? (
                                  <div className="mt-3">
                                    {this.renderTicketCounter(
                                      'Adult',
                                      this.state.adultTicketCount,
                                      this.state.adultTicketPrice,
                                      this.incrementAdultTicket,
                                      this.decrementAdultTicket
                                    )}
                                    <div className="mt-3">
                                      {this.renderTicketCounter(
                                        'Child',
                                        this.state.childTicketCount,
                                        this.state.childTicketPrice,
                                        this.incrementChildTicket,
                                        this.decrementChildTicket
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  this.renderEmptyState(
                                    'ticket',
                                    'No tickets available',
                                    'Please select a valid time slot'
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Additional Fields */}
                    <div className="d-flex gap-20 mt-3">
                      <div className="w-100">
                        <div className="additionl-box">
                          <label className="col-form-label colformlabel w-100">Cost Of Service</label>
                          <input
                            type="number"
                            min={0}
                            className="form-control border-radius"
                            name="cost_of_service"
                            value={this.state.cost_of_service}
                            onChange={this.handleChange}
                            placeholder="Cost Of Service"
                          />
                        </div>
                      </div>
                      <div className="w-100">
                        <div className="additionl-box">
                          <label className="col-form-label colformlabel w-100">Coupon Code</label>
                          <div
                            className="input-group d-flex"
                            style={{ marginBottom: '0', overflow: 'hidden' }}
                          >
                            <input
                              type="text"
                              className="form-control border-radius"
                              name="coupon"
                              value={this.state.coupon}
                              onChange={this.handleChange}
                              placeholder="Coupon Code"
                              style={{ borderRight: '0' }}
                              disabled={this.state.isCouponApplied}
                            />
                            {this.state.isCouponApplied ? (
                              <button
                                className="btn custom-apply-btn"
                                onClick={this.removeCoupon}
                                type="button"
                              >
                                Remove
                              </button>
                            ) : (
                              <button
                                className="btn custom-apply-btn"
                                onClick={this.validateCoupon}
                                type="button"
                                disabled={!this.state.coupon.trim()}
                              >
                                Apply
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Customer Information */}
                    <div className="d-flex gap-20">
                      <div className="w-100 mt-3">
                        <div className="additionl-box">
                          <label className="col-form-label colformlabel w-100">
                            Customer Number {this.state.isCustomerOptional ? '(Optional)' : ''}
                          </label>
                          <div className="d-flex form-control contact-filed border-radius">
                            <input
                              style={{ width: '30%' }}
                              type="text"
                              className="border-none input-border"
                              name="country_code"
                              value={this.state.country_code}
                              onChange={this.handleChange}
                              placeholder="Country Code"
                            />
                            <input
                              type="text"
                              className="form-control border-none"
                              style={{ width: '70%' }}
                              name="phone"
                              value={this.state.phone}
                              onChange={this.handleChange}
                              placeholder="Contact Number"
                              maxLength={10}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-100 mt-3">
                        <div className="additionl-box">
                          <label className="col-form-label colformlabel w-100">Customer Email (Optional)</label>
                          <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                            <input
                              type="email"
                              className={`form-control border-radius ${this.state.emailError ? 'is-invalid' : ''}`}
                              name="email"
                              value={this.state.email}
                              onChange={this.handleChange}
                              placeholder="Customer Email"
                              style={
                                this.state.emailError ? { borderColor: '#dc3545', width: '100%' } : { width: '100%' }
                              }
                            />
                            {this.state.emailError && (
                              <div
                                style={{
                                  color: '#dc3545',
                                  fontSize: '12px',
                                  marginTop: '5px',
                                  textAlign: 'left',
                                }}
                              >
                                {this.state.emailError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex gap-20">
                      <div className="w-100 d-flex mt-3 align-items-end justify-content-end">
                        {this.state.isBooking ? (
                          <button
                            className="btn btn-grd-disabled mr-2"
                            disabled
                          >
                            <i
                              className="icofont icofont-spinner icofont-spin"
                              style={{ marginRight: 8 }}
                            ></i>
                            Processing Booking...
                          </button>
                        ) : (
                          <>
                            <button
                              type="button"
                              onClick={this.handleBooking}
                              className="btn book-btn btn-grd-disabled mr-2"
                            >
                              <i className="icofont icofont-save"></i> Book
                            </button>
                            <button
                              type="button"
                              onClick={this.resetForm}
                              className="btn clear-btn btn-grd-disabled"
                            >
                              <i className="icofont icofont-clear"></i> Clear
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderEventDetailsModal()}
        {this.renderPaymentConfirmationModal()}

        {/* Addons popup */}
        {!!this.state.addOnPopUp && (
          <div
            className="popup-backdrop"
            onClick={() =>
              this.setState({
                addOnPopUp: 0,
                appOnData: {},
              })
            }
          >
            <div
              className="popup-content-2 p-0"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="h-100 position-relative">
                <button
                  className="popup-close"
                  onClick={() =>
                    this.setState({
                      addOnPopUp: 0,
                      appOnData: {},
                    })
                  }
                >
                  <img
                    src="./assets/icon/concierge/close-black.svg"
                    alt=""
                  />
                </button>
                <KashtaAddOns
                  data={this.state.appOnData}
                  handleDataFromChild={this.handleDataFromChild}
                  clearData={this.resetForm}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default ConciergeKashtaAdd
